module.exports = __webpack_public_path__ + "media/images/pic/wsjj-team-mobile-ed42f8b44f1075b4ff9e1c4fd5275d5a.webp";